import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path1/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path1/src/context/ThemeContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/styles/Footer.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/styles/Layout.module.css");
